var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-area border-t border-b border-green-500"},[_c('O3DEditor',{staticClass:"h-full w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }